import { OptionHTMLAttributes, SelectHTMLAttributes } from "react";
import styles from "./Select.module.css";
import clsx from "clsx";

type SelectProps = {
  variant?: "default" | "soft";
} & SelectHTMLAttributes<HTMLSelectElement>;

export function Select({ variant = "default", className, ...props }: SelectProps) {
  return (
    <select data-variant={variant} className={clsx(styles.selectRoot, className)} {...props} />
  );
}

type SelectOptionProps = OptionHTMLAttributes<HTMLOptionElement>;
Select.Option = function (props: SelectOptionProps) {
  return <option {...props} />;
};
